import { render, staticRenderFns } from "./JCElderAbility.vue?vue&type=template&id=13ef6169&"
import script from "./JCElderAbility.vue?vue&type=script&lang=js&"
export * from "./JCElderAbility.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports